import styled from 'styled-components';

import { SectionRenderer } from '../components/blocks/SectionRenderer';
import { TeamMemberCard } from '../components/blocks/TeamMemberCard';
import { Container } from '../components/primitives/Container';
import { SectionHead } from '../components/primitives/SectionHead';
import { useContent } from '../content/load';
import { useDocumentTitle } from '../lib/seo';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: ${(p) => p.theme.step[6]}px;
  padding: ${(p) => p.theme.step[5]}px 0 ${(p) => p.theme.step[8]}px;
`;

export default function About() {
  const { team, pages } = useContent();
  const page = pages.about;
  useDocumentTitle(page?.seo.title, page?.seo.description);
  return (
    <Container>
      {page ? (
        page.sections.map((s, i) => <SectionRenderer key={i} section={s} />)
      ) : (
        <SectionHead
          eyebrow="ABOUT"
          heading="A small team that ships."
          body="PowerQuant is a systematic trading firm — equal parts research, engineering, and risk."
        />
      )}
      <Grid>
        {team.map((m) => (
          <TeamMemberCard key={m.id} member={m} />
        ))}
        {team.length === 0 && <p style={{ opacity: 0.7 }}>(Team profiles land in PR 07.)</p>}
      </Grid>
    </Container>
  );
}
